import script from "./SaddleSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaddleSelection.vue?vue&type=script&setup=true&lang=ts"

import "./SaddleSelection.vue?vue&type=style&index=0&id=1caf0c28&lang=scss"

const __exports__ = script;

export default __exports__